export default "__VITE_PUBLIC_ASSET__14dff7f8__"